import { useQuery } from 'react-query'
import { useAuth0 } from '../../../contexts/auth0-context'
import callAPI from '../../../API/callSecureAPI'

export type UserActivityStats = {
    _id: string
    userId: string
    userName: string
    userEmail: string
    organizationId: string
    organizationName: string
    eventCount: number
    lastActivity: string
    firstActivity: string
    activeDays: number
    actionBreakdown: Record<string, number>
}

export type ActivityByDay = {
    _id: string
    date: string
    totalEvents: number
    uniqueUsers: number
}

export type UserActivityResponse = {
    success: boolean
    data: {
        userStats: UserActivityStats[]
        activityByDay: ActivityByDay[]
        totalEvents: number
        uniqueUsers: number
        distinctActions: string[]
    }
}

const FIVE_MINUTES = 1000 * 60 * 5

export const useAdminUserActivityQuery = (days: number = 30) => {
    const { getTokenSilently, isAuthenticated, isLoading } = useAuth0()

    const getUserActivity = async () => {
        try {
            const token = await getTokenSilently?.({ audience: 'https://atlas.aesara.com' })
            const response = await callAPI(`/api/admin/user-activity?days=${days}`, 'get', token)
            return response
        } catch (e) {
            console.error('Error fetching user activity:', e)
            throw e
        }
    }

    return useQuery<UserActivityResponse>(['admin', 'user-activity', days], getUserActivity, {
        enabled: !!getTokenSilently && !!isAuthenticated && !isLoading,
        cacheTime: FIVE_MINUTES,
        staleTime: 60000,
        retry: 2,
    })
}
